import { Loader2 } from "lucide-react";
import { FrontImage } from "./FrontImage";
import { blankOnError } from "../lib/api";

// Original photo next to the selected AI render.
export const RenderComparison = ({ creation, renders, selected, regenerating }) => (
  <div className="grid md:grid-cols-2 gap-5">
    <figure className="rounded-3xl overflow-hidden border border-border bg-card">
      <img src={creation.photo} alt="original" onError={blankOnError} className="w-full aspect-square object-cover" />
      <figcaption className="p-3 text-center text-xs font-mono2 uppercase tracking-widest text-muted-foreground">
        {creation.source === "render" ? "Uploaded image" : "Original photo"}
      </figcaption>
    </figure>
    <figure className="rounded-3xl overflow-hidden border-2 border-primary bg-card duck-shadow relative">
      {regenerating && (
        <div className="absolute inset-0 z-10 grid place-items-center bg-background/70 backdrop-blur-sm">
          <Loader2 className="h-8 w-8 animate-spin text-accent" />
        </div>
      )}
      <FrontImage creation={creation} testId="face-preview-image" alt="stylized duck figurine render" className="w-full aspect-square object-cover" />
      <figcaption data-testid="render-caption" className="p-3 text-center text-xs font-mono2 uppercase tracking-widest text-accent font-semibold">
        🦆 {creation.name || "Your rubber-duck figurine"} · Rev {creation.version || 1}
        {renders.length > 1 ? ` · option ${selected + 1} of ${renders.length}` : ""}
        {creation.source === "render" ? " · your image" : ""}
      </figcaption>
    </figure>
  </div>
);
